// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_container__NllXg {
  width: 50px;
  height: 50px;
  position: relative;
}

@keyframes style_moveStar1__KhqP1 {
  from {
    transform: translate(10px, 10px);
  }
}

@keyframes style_moveStar2__U-1lV {
  from {
    transform: translate(0, 0);
  }
  to {
    transform: translate(15px, 12px);
  }
}

@keyframes style_moveStar3__J7fAR {
  from {
    transform: translate(0, 0);
  }
  to {
    transform: translate(-15px, 12px);
  }
}

@keyframes style_moveStar4__NQxK7 {
  from {
    transform: translate(0, 0);
  }
  to {
    transform: translate(8px, 30px);
  }
}

@keyframes style_moveStar5__rhoDK {
  from {
    transform: translate(0, 0);
  }
  to {
    transform: translate(-10px, 30px);
  }
}

.style_item1__gtYMk,
.style_item2__88Ibl,
.style_item3__mFYXS,
.style_item4__HP2WE,
.style_item5__hKvAl {
  position: absolute;
}

.style_item2__88Ibl {
  animation: style_moveStar2__U-1lV 3s forwards;
}
.style_item3__mFYXS {
  animation: style_moveStar3__J7fAR 3s forwards;
}
.style_item4__HP2WE {
  animation: style_moveStar4__NQxK7 3s forwards;
}
.style_item5__hKvAl {
  animation: style_moveStar5__rhoDK 3s forwards;
}
`, "",{"version":3,"sources":["webpack://./src/components/shops/style.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,iCAAiC;EACnC;AACF;;AAEA;;;;;EAKE,kBAAkB;AACpB;;AAEA;EACE,6CAAgC;AAClC;AACA;EACE,6CAAgC;AAClC;AACA;EACE,6CAAgC;AAClC;AACA;EACE,6CAAgC;AAClC","sourcesContent":[".container {\n  width: 50px;\n  height: 50px;\n  position: relative;\n}\n\n@keyframes moveStar1 {\n  from {\n    transform: translate(10px, 10px);\n  }\n}\n\n@keyframes moveStar2 {\n  from {\n    transform: translate(0, 0);\n  }\n  to {\n    transform: translate(15px, 12px);\n  }\n}\n\n@keyframes moveStar3 {\n  from {\n    transform: translate(0, 0);\n  }\n  to {\n    transform: translate(-15px, 12px);\n  }\n}\n\n@keyframes moveStar4 {\n  from {\n    transform: translate(0, 0);\n  }\n  to {\n    transform: translate(8px, 30px);\n  }\n}\n\n@keyframes moveStar5 {\n  from {\n    transform: translate(0, 0);\n  }\n  to {\n    transform: translate(-10px, 30px);\n  }\n}\n\n.item1,\n.item2,\n.item3,\n.item4,\n.item5 {\n  position: absolute;\n}\n\n.item2 {\n  animation: moveStar2 3s forwards;\n}\n.item3 {\n  animation: moveStar3 3s forwards;\n}\n.item4 {\n  animation: moveStar4 3s forwards;\n}\n.item5 {\n  animation: moveStar5 3s forwards;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style_container__NllXg`,
	"item1": `style_item1__gtYMk`,
	"item2": `style_item2__88Ibl`,
	"item3": `style_item3__mFYXS`,
	"item4": `style_item4__HP2WE`,
	"item5": `style_item5__hKvAl`,
	"moveStar2": `style_moveStar2__U-1lV`,
	"moveStar3": `style_moveStar3__J7fAR`,
	"moveStar4": `style_moveStar4__NQxK7`,
	"moveStar5": `style_moveStar5__rhoDK`,
	"moveStar1": `style_moveStar1__KhqP1`
};
export default ___CSS_LOADER_EXPORT___;
